import React, { useState, useEffect, useRef } from 'react'
import { useGeoState,useGeoFetch } from '../../components/GeoProvider'
import styles from './DashboardPage.module.scss'
import Spinner from '../../components/Loader/Spinner'
import MapLegend from './cdcMapLegend8LevelHorizontal'
import Map from '../../components/Map'
import toolTipFormatter from './toolTipFormatter'
const DashboardPage = () => {
    const {
        dataStartDate,
        dataEndDate,
        mapOptions,
        regionSelected,
        setRegionSelected,
        setExportButtonEnable,
        setDisplayDate
      } = useGeoState()
    const chartRef = useRef(null)
    const [getMapStates, setMapStates] = useState()
    const [getStateJson, setStateJson] = useState()
    const { data: statesData, error: MapError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    'utimap',
    'STATE',
    false,
    {geo_parent:'US'}
  )

  useEffect(() => {
    if (statesData !== null && statesData !== undefined) {
      if (statesData.response_code === 200) { 
        var datacount= Object.keys(statesData.response_data).length-1                
        setDisplayDate(Object.keys(statesData.response_data).sort()[datacount])       
        setMapStates(statesData.response_data)
      } else {
        // setErrorCode(statesData.response_code)
        // setErrorMessage(statesData.response_message)
        // setErrorSubject(statesData.response_subject)
        // seterrorOccured(true)
      }
    }
  }, [statesData])
useEffect(() => {
    let url = `${window.location.origin}/rsv/usStatesAll.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        setStateJson(data)
      })
      .catch(function (err) {
        console.log(err, ' error file usStatesAll.json')
      })
  }, [1])
    return (
    <div className={`${styles.base}`}>
        <div className={styles.mapPanel}>
            {getMapStates !== undefined && getStateJson!==undefined?
            <div>
                 {/* <div className={styles.legendDiv}>
                <MapLegend />
                </div> */}
                <Map
                  toolTipFormatter={toolTipFormatter}
                  activeCbsasData={null}
                  statesData={getMapStates}
                  cbsaData={null}
                  mapOptions={mapOptions}
                  dynamicMapTitle={true}
                  mapType="RSVMAP"
                  enableButtons={true}
                  chartRef={chartRef}
                  mapDataType={0}
                  stateJson={getStateJson}
                  dashboardType="uti"
                  mapTitleDisable={true}
                />
            </div>
            :
            <Spinner/>
            }
        </div>
        <div className={styles.tablePanel}>Hi1</div>
    </div>
    )

}
export default DashboardPage